"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNetworkRoleToLocation = exports.LogisticsNetworkRoles = void 0;
const location_1 = require("./location");
var LogisticsNetworkRoles;
(function (LogisticsNetworkRoles) {
    LogisticsNetworkRoles["LogisticsNetworkAdmin"] = "Logistics Network Admin";
    LogisticsNetworkRoles["LogisticsNetworkReader"] = "Logistics Network Reader";
    LogisticsNetworkRoles["LogisticsNetworkOperator"] = "Logistics Network Operator";
})(LogisticsNetworkRoles = exports.LogisticsNetworkRoles || (exports.LogisticsNetworkRoles = {}));
function mapNetworkRoleToLocation(role) {
    if (role === LogisticsNetworkRoles.LogisticsNetworkAdmin) {
        return location_1.LogisticsLocationRoles.LogisticsManager;
    }
    else if (role === LogisticsNetworkRoles.LogisticsNetworkOperator) {
        return location_1.LogisticsLocationRoles.LogisticsOperator;
    }
    else {
        return undefined;
    }
}
exports.mapNetworkRoleToLocation = mapNetworkRoleToLocation;
//# sourceMappingURL=logistics-network.js.map